import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TarlV3JsonapiModule } from '®shared/tarl-v3-jsonapi';

import { TenantService } from './tenant.service';

@NgModule({
  imports: [CommonModule, TarlV3JsonapiModule],
  providers: [TenantService],
})
export class TenantModule {}
